import { LocationWithImageData } from 'lib/types';
import { graphql, useStaticQuery } from 'gatsby';

export const query = graphql`
    fragment ImageData on Upload {
        ...LocationImageCardImage
    }

    fragment LocationImageData on LocationImage {
        main
        image {
            ...ImageData
        }
    }

    fragment LocationWithImageData on Location {
        ...LocationData
        mainImage {
            ...ImageData
        }
        images {
            ...LocationImageData
        }
        cardImage {
            ...LocationImageCardUpload
        }
        heroImage: pageImage(slug: "hero.heroImage") {
            slug
            alt
            image {
                ...LocationImageCardUpload
            }
        }
    }
    query LocationsWithImagesQuery {
        allLocation {
            nodes {
                ...LocationWithImageData
            }
        }
    }
`;

type LocationsWithImagesQuery = {
    allLocation: {
        nodes: ReadonlyArray<LocationWithImageData>;
    };
};

export default function useLocationsWithImages(): ReadonlyArray<LocationWithImageData> {
    const {
        allLocation: { nodes: locations },
    } = useStaticQuery<LocationsWithImagesQuery>(query);

    return locations
        .filter(({ coordinates }) => !!coordinates)
        .sort((a, b) => {
            const aSortOrder =
                a.sortOrder === undefined
                    ? Number.MAX_SAFE_INTEGER
                    : a.sortOrder;
            const bSortOrder =
                b.sortOrder === undefined
                    ? Number.MAX_SAFE_INTEGER
                    : b.sortOrder;

            return aSortOrder - bSortOrder;
        }) as ReadonlyArray<LocationWithImageData>;
}
